export const CORE_PALETTES_TOGGLE_OPERATION_PALETTE =
  'operation::@bangle.io/core-palettes:TOGGLE_OPERATION_PALETTE';

export const CORE_PALETTES_TOGGLE_WORKSPACE_PALETTE =
  'operation::@bangle.io/core-palettes:TOGGLE_WORKSPACE_PALETTE';

export const CORE_PALETTES_TOGGLE_NOTES_PALETTE =
  'operation::@bangle.io/core-palettes:TOGGLE_NOTES_PALETTE';

export enum CorePalette {
  Heading = 'bangle-io-core-palettes/heading',
  Workspace = 'bangle-io-core-palettes/workspace',
  Question = 'bangle-io-core-palettes/question',
  Operation = 'bangle-io-core-palettes/operation',
  Notes = 'bangle-io-core-palettes/notes',
}
